
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef } from 'react';
import { IconTypes, RenderIcons } from '../components/controls/icons';


const _t = (function () {
    var obje = {title: '', message: '', delayInMs: 1000, closable : true, content: '', sticky: false}
    var p_fun = (details = obje) =>{}
    var toast = { success: p_fun, info: p_fun, error: p_fun, warning: p_fun, show : (obj = {...obje, type: ''})=>{} }

    function init(instance, show_callback) {
        var _show = (obj = {}) => {
            if (instance && typeof instance.show === 'function' && typeof show_callback === 'function') {
                const content = obj.content ||
                <div className='toster_area'>
                    <div>{obj.icon}</div>
                    <div className='toster_text_area'>
                        <span className='toster_text_title'>{obj.title}</span>
                        <span className='toster_text_msg'>{obj.message}</span>
                    </div>
                </div>
                show_callback({
                    severity: obj.severity, 
                    summary: obj.title, 
                    detail: obj.message, 
                    life: obj.delayInMs || 3000, 
                    content: content,
                    closable: obj.closable,
                    sticky: obj.sticky
                })
            }
        }

        toast.success = (obj = obje) =>{
            _show({...obj, severity: 'success', icon: RenderIcons(IconTypes.Success)})
        }
        toast.info = (obj = obje) =>{
            _show({...obj, severity: 'info'})
        }
        toast.error = (obj = obje) =>{
            _show({...obj, severity: 'error', icon: RenderIcons(IconTypes.Error)})
        }
        toast.warning = (obj = obje) =>{
            _show({...obj, severity: 'warn', icon: RenderIcons(IconTypes.Warning)})
        }
        toast.show = (obj = {...obje, type: ''}) =>{
            _show({...obj})
        }

    }
    return {
        init: init,
        Item: toast
    }
})();





function AppToastContainer() {
    const toast_ref = useRef(null);
    let timeout;
    useEffect(() => {
        _t.init(toast_ref.current, showSuccess);
        return ()=>{
            clearTimeout(timeout)
        }
    })

    function showSuccess(ob) {
        if (toast_ref.current){
            timeout = setTimeout(()=>{
                toast_ref.current.show(ob);
            }, 0)
        }
    }



    return <Toast ref={toast_ref} />
}

export const AppToast = {
    AppToastContainer: AppToastContainer,
    Toast: _t.Item
}

